import { Buffer } from 'buffer';

type GetLoginPageUrlParametersOptions = {
  charityName?: string;
  campaignTitle?: string;
  campaignId?: string;
  causeLogo?: string;
  eventName?: string;
  title?: string;
};

export function getLoginPageUrlParameters({
  campaignId,
  campaignTitle,
  causeLogo,
  charityName,
  eventName,
  title,
}: GetLoginPageUrlParametersOptions) {
  if (title && !charityName) {
    return getEncodedOptions({
      title,
    });
  }
  if (!charityName) {
    return;
  }

  return getEncodedOptions({
    title: title,
    image: causeLogo,
    message: `<p>Welcome to JustGiving! Let's set up your <strong>${eventName ??
      ''} ${
      campaignId && eventName !== campaignTitle ? campaignTitle : ''
    }</strong> fundraising page and start raising money for <strong>${charityName}</strong>.</p>`,
  });
}

type GetEncodedOptions = {
  message?: string;
  image?: string;
  title?: string;
};

export function getEncodedOptions({
  message,
  image,
  title,
}: GetEncodedOptions) {
  const options = {
    Message: message,
    MessageImage: image,
    SignInTitle: title,
  };

  const utf8Options = Buffer.from(JSON.stringify(options), 'utf-8');
  const base64Options = utf8Options.toString('base64');
  return base64Options;
}
